import { Spin } from "antd";
import { useEffect, useState } from "react";
import EditButton from "../../../components/buttons/edit";
import LocaisForm from "../../../components/locais/form";
import {
    InlineContainer,
    TitleHeader,
    VerticalContainer,
} from "../../../components/styled";
import ViewContainer from "../../../components/view_container";
import { getLocalViagem, updateLocalViagem } from "../../../services/locais";

export default function EditLocal({ computedMatch }) {
  const [error, setError] = useState();
  const [local, setLocal] = useState();
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const { params } = computedMatch;
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateLocalViagem(local, values);
    } catch (err) {
      console.log(err);
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  const handleLocalViagem = async () => {
    const data = await getLocalViagem(params.id);
    setLocal(data);
  };

  useEffect(() => {
    handleLocalViagem();
  }, []);

  return (
    <>
      {local ? (
        <VerticalContainer>
          <InlineContainer>
            <TitleHeader></TitleHeader>
            <EditButton viewMode={viewMode} setViewMode={setViewMode} />
          </InlineContainer>

          <ViewContainer item={local}>
            <LocaisForm
              initialValues={{ ...local }}
              onFinish={onFinish}
              error={error}
              setError={setError}
              loading={loading}
              viewMode={viewMode}
            />
          </ViewContainer>
        </VerticalContainer>
      ) : (
        <Spin />
      )}
    </>
  );
}
